function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIdentificationDocumentRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 17.086l-.04.644c-.132 2.136-.725 5.481-2.137 8.113-.686 1.28-2.148 2.286-3.258 2.927a19.175 19.175 0 01-2.005 1.004c-.057.025-.104.044-.136.057l-.038.016-.011.005h-.005L22 30l-.37-.146-.005-.002-.01-.005-.039-.016-.137-.057a19.175 19.175 0 01-2.005-1.004c-1.11-.641-2.57-1.648-3.257-2.927-1.412-2.632-2.005-5.977-2.137-8.113l-.04-.644L22 13l8 4.086zm-8.155 5.845l-2.43-2.345L18 22l3.293 3.207a1 1 0 001.539-.152L26.5 19.5l-1.832-1.055-2.823 4.486zM19 2a2 2 0 012 2v7.5L12 16c0 4.5 1.327 8 1.327 8H4a2 2 0 01-2-2V4a2 2 0 012-2h15zM6 15v2h4v-2H6zm0-4v2h7v-2H6zm0-4v2h10V7H6z",
    fill: props.color
  }));
}

export default SvgIconIdentificationDocumentRexFilled;